import { render } from "./Tags.vue?vue&type=template&id=3905159b&scoped=true"
import script from "./Tags.vue?vue&type=script&lang=ts"
export * from "./Tags.vue?vue&type=script&lang=ts"

import "./Tags.vue?vue&type=style&index=0&id=3905159b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3905159b"

export default script